import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ProfileInformationIcon = (props: SvgProps) => <Svg
  width='18'
  height='20'
  viewBox='0 0 18 20'
  fill='none'
  {...props}>
  <Path
    d='M14 6C14 6.98891 13.7068 7.95561 13.1573 8.77785C12.6079 9.6001 11.827 10.241 10.9134 10.6194C9.99979 10.9978 8.99445 11.0969 8.02455 10.9039C7.05464 10.711 6.16373 10.2348 5.46447 9.53553C4.7652 8.83627 4.289 7.94536 4.09607 6.97545C3.90315 6.00555 4.00216 5.00021 4.3806 4.08658C4.75904 3.17295 5.3999 2.39206 6.22215 1.84265C7.04439 1.29324 8.01109 1 9 1C10.3261 1 11.5979 1.52678 12.5355 2.46447C13.4732 3.40215 14 4.67392 14 6ZM6 11C4.67392 11 3.40215 11.5268 2.46447 12.4645C1.52678 13.4021 1 14.6739 1 16V16V17C1 17 3 19 9 19C15 19 17 17 17 17V16C17 14.6739 16.4732 13.4021 15.5355 12.4645C14.5979 11.5268 13.3261 11 12 11H6Z'
    stroke={props.color ?? '#3379BD'}
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default ProfileInformationIcon;
